// /* eslint-disable eslint-comments/disable-enable-pair */

import { takeLatest, put, all, call } from 'redux-saga/effects';

import BranchDetailsActionTypes from './branch-details.types';
import {
	branchDetailsAdd,
	fetchBranchDetails,
	updateBranchDetails,
} from './branch-details.service';

import {
	addBusinessBranchSuccess,
	addBusinessBranchFailure,
	addBusinessBranchResponseChanged,
	fetchBusinessBranchSuccess,
	fetchBusinessBranchFailure,
	fetchBusinessBranchResponseChanged,
	updateBusinessBranchSuccess,
	updateBusinessBranchFailure,
	updateBusinessBranchResponseChanged,
} from './branch-details.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START ADD BUSINESS BRANCH  ******************** */
export function* businessBranchAdd({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName, branchListArr } = payload;
		const key = 'BusinessBranchKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			BusinessBranchList: branchListArr,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(branchDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addBusinessBranchFailure(responseData.data));
		} else {
			yield put(addBusinessBranchSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addBusinessBranchFailure(error));
	}
}

export function* resetAddBusinessBranchResponse() {
	yield put(addBusinessBranchResponseChanged());
}

export function* onAddBusinessBranchDetails() {
	yield takeLatest(BranchDetailsActionTypes.ADD_BUSINESS_BRANCH_START, businessBranchAdd);
}

export function* onAddBusinessBranchResponseReset() {
	yield takeLatest(
		BranchDetailsActionTypes.ADD_BUSINESS_BRANCH_RESPONSE_RESET,
		resetAddBusinessBranchResponse,
	);
}
/** *********************  END ADD BUSINESS BRANCH ******************** */

/** *********************  START FETCH BUSINESS BRANCH  ******************** */
export function* businessBranchFetch({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName } = payload;
		const key = 'GetBusinessBranchKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
		};
		const updateData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(fetchBranchDetails, updateData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBusinessBranchFailure(responseData.data));
		} else {
			yield put(fetchBusinessBranchSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBusinessBranchFailure(error));
	}
}

export function* resetFetchBusinessBranchResponse() {
	yield put(fetchBusinessBranchResponseChanged());
}

export function* onFetchBusinessBranchDetails() {
	yield takeLatest(BranchDetailsActionTypes.FETCH_BUSINESS_BRANCH_START, businessBranchFetch);
}

export function* onFetchBusinessBranchResponseReset() {
	yield takeLatest(
		BranchDetailsActionTypes.FETCH_BUSINESS_BRANCH_RESPONSE_RESET,
		resetFetchBusinessBranchResponse,
	);
}
/** *********************  END FETCH BUSINESS BRANCH ******************** */

/** *********************  START UPDATE BUSINESS BRANCH  ******************** */
export function* businessBranchUpadate({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName, branchListArr } = payload;
		const key = 'UpdateBusinessBranchKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			BusinessBranchList: branchListArr,
		};
		const updateData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(updateBranchDetails, updateData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateBusinessBranchFailure(responseData.data));
		} else {
			yield put(updateBusinessBranchSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateBusinessBranchFailure(error));
	}
}

export function* resetUpdateBusinessBranchResponse() {
	yield put(updateBusinessBranchResponseChanged());
}

export function* onUpdateBusinessBranchDetails() {
	yield takeLatest(BranchDetailsActionTypes.UPDATE_BUSINESS_BRANCH_START, businessBranchUpadate);
}

export function* onUpdateBusinessBranchResponseReset() {
	yield takeLatest(
		BranchDetailsActionTypes.UPDATE_BUSINESS_BRANCH_RESPONSE_RESET,
		resetUpdateBusinessBranchResponse,
	);
}
/** *********************  END UPDATE BUSINESS BRANCH ******************** */

export function* branchDetailsSaga() {
	yield all([
		call(onAddBusinessBranchDetails),
		call(onAddBusinessBranchResponseReset),
		call(onFetchBusinessBranchDetails),
		call(onFetchBusinessBranchResponseReset),
		call(onUpdateBusinessBranchDetails),
		call(onUpdateBusinessBranchResponseReset),
	]);
}
